import _JSON$stringify from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/json/stringify";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import { isIos } from "@/utils/lodash";
import generalUtils from "@/utils/generalUtils";
import { iap_service } from "@/api/faceServe/index";
import { sendMapEvent } from "@/utils/analytics";
import { erroToMsg } from "@/utils/errorToMsg";
import store from "@/store/index";
import * as types from "@/store/constants/types";
import { i18n } from "@/i18n/i18n-setup";
export var iapService = function iapService(_ref) {
  var transaction_id = _ref.transaction_id,
      receipt = _ref.receipt,
      offer_id = _ref.offer_id;
  var oriReject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(resolve, reject) {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return iap_service({
                transaction_id: transaction_id,
                receipt: receipt,
                offer_id: offer_id
              });

            case 3:
              result = _context.sent;
              resolve(result);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              //如果报错：
              store.commit(types.SHOW_TOAST, {
                show: true,
                topImg: require("@/assets/icons/toast/post_offer_fail.png"),
                title: i18n.t("toast.payment_failed_title"),
                content: i18n.t("toast.payment_failed_content"),
                confirm: "<div class=\"flex-center\" style=\"width:100%;height:100%;background:#603BF3;color: #fff;border-radius:12px;font-family:Assistant-SemiBold;font-size:16px;\">".concat(i18n.t("toast.retry"), "</div>"),
                cancel: "<div class=\"flex-center\" style=\"width:100%;height:100%;color:#CDCBD6;\">".concat(i18n.t("toast.cancel"), "</div>"),
                confirmFn: function confirmFn() {
                  store.commit(types.UPDATE_LOADING_STATUS, true);

                  if (oriReject === null) {
                    iapService({
                      transaction_id: transaction_id,
                      receipt: receipt,
                      offer_id: offer_id
                    }, reject);
                  } else {
                    iapService({
                      transaction_id: transaction_id,
                      receipt: receipt,
                      offer_id: offer_id
                    }, oriReject);
                  }
                },
                cancelFn: function cancelFn() {
                  //reject为最先开始的reject,
                  if (oriReject === null) {
                    reject(_context.t0);
                  } else {
                    oriReject(_context.t0);
                  }
                }
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }());
};
export var payByIap = function payByIap(offer_id) {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(resolve, reject) {
      var is_sub, product_id, purchaseResult, transaction_id, receipt, result, price, _is_sub;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              // 是否是订阅类型
              is_sub = generalUtils.isSubsOffer(offer_id); // console.log("is_sub", is_sub);

              product_id = generalUtils.getProductIdByOfferId(offer_id, "iap");
              console.log("product_id", product_id);

              if (!is_sub) {
                _context2.next = 11;
                break;
              }

              console.log("subscribe product_id:", product_id);
              _context2.next = 8;
              return inAppPurchase.subscribe(product_id);

            case 8:
              purchaseResult = _context2.sent;
              _context2.next = 15;
              break;

            case 11:
              console.log("buy product_id:", product_id);
              _context2.next = 14;
              return inAppPurchase.buy(product_id);

            case 14:
              purchaseResult = _context2.sent;

            case 15:
              console.log("purchaseResult:", purchaseResult);
              transaction_id = "";

              if (isIos()) {
                transaction_id = purchaseResult.transactionId;
                receipt = purchaseResult.receipt;
              } else {
                transaction_id = JSON.parse(purchaseResult.receipt).orderId;
                receipt = JSON.parse(purchaseResult.receipt);
              }

              _context2.next = 20;
              return iapService({
                transaction_id: transaction_id,
                receipt: receipt,
                offer_id: offer_id
              });

            case 20:
              result = _context2.sent;
              console.log("iap_service data:", result);
              console.log("iap_service json:", _JSON$stringify(result));
              resolve(result);
              price = generalUtils.getPriceByOfferId(offer_id); //打点：

              try {
                Cordova.exec(function (res) {
                  console.info("IapLogWithParam:", res);
                }, function (error) {
                  console.info("IapLogWithParam error:", error);
                }, "ThirdPartyPlugin", "IapLogWithParam", [{
                  isFree: !generalUtils.isRenew(),
                  isSubscription: is_sub,
                  price: price,
                  offerId: offer_id // receipt: purchaseResult.receipt

                }]);
              } catch (error) {}

              _context2.next = 33;
              break;

            case 28:
              _context2.prev = 28;
              _context2.t0 = _context2["catch"](0);
              console.log("payByIap error:", _context2.t0);
              reject(_context2.t0); //错误打点

              try {
                if (isIos()) {
                  sendMapEvent("uia_pay_by_iap_failed", {
                    error_code: "",
                    error_message: erroToMsg(_context2.t0)
                  });
                } else {
                  sendMapEvent("purchase_google_results", {
                    error_code: "",
                    error_message: erroToMsg(_context2.t0)
                  });
                  _is_sub = generalUtils.isSubsOffer(offer_id);

                  if (_is_sub) {
                    sendMapEvent("google_iap_subscribe", {
                      error_code: "",
                      error_message: erroToMsg(_context2.t0)
                    });
                  }
                }
              } catch (error) {}

            case 33:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 28]]);
    }));

    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }());
};